var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-modal",
    {
      attrs: { value: _vm.value, "escape-close": "" },
      on: {
        input: function ($event) {
          return _vm.onInput($event)
        },
      },
    },
    [
      _c(
        "w-card",
        { attrs: { "max-width": 900 } },
        [
          _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("import-views")))]),
          !_vm.selectedUser
            ? _c(
                "w-scroll-view",
                { attrs: { tag: "w-list" } },
                _vm._l(_vm.users, function (user) {
                  return _c(
                    "w-list-item",
                    {
                      key: user.ID,
                      on: {
                        click: function ($event) {
                          return _vm.selectUser(user)
                        },
                      },
                    },
                    [
                      _c("w-list-item-text", [
                        _vm._v(_vm._s(user.getUserString())),
                      ]),
                    ],
                    1
                  )
                }),
                1
              )
            : _vm._e(),
          _c("app-users-select-views", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.selectedUser,
                expression: "selectedUser",
              },
            ],
            attrs: {
              "overwrite-existing-views": _vm.overwriteExistingViews,
              "user-id": _vm.selectedUserId,
              "selected-views": _vm.selectedViews,
            },
            on: {
              "update:overwriteExistingViews": function ($event) {
                _vm.overwriteExistingViews = $event
              },
              "update:overwrite-existing-views": function ($event) {
                _vm.overwriteExistingViews = $event
              },
            },
          }),
          _c(
            "w-card-actions",
            [
              _c(
                "w-button",
                {
                  staticClass: "cancel",
                  attrs: { icon: "ban" },
                  on: {
                    click: function ($event) {
                      return _vm.cancel()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("common.cancel")) + " ")]
              ),
              _c("w-spacer"),
              _c(
                "w-button",
                {
                  attrs: {
                    disabled:
                      _vm.selectedUser == null || _vm.selectedViews.length == 0,
                    icon: "check",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.importViews()
                    },
                  },
                },
                [_vm._v(" " + _vm._s(_vm.$ct("import")) + " ")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }